import ProductHeaderDetail from "@scenes/pdp/utils/ProductHeaderDetail";
import styled from "styled-components/native";
import { ProductHeaderViewProps } from "./types";
import { Platform } from "react-native";
import { css } from "styled-components/native";
import { matchPairConatinerWidth } from "@scenes/findMatch/utils";
import { useAvailabilityData } from "../../../../hooks/useAvailabilityData";
import { usePdpLayout } from "@redux/slices/pdpLayoutSlice";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { useProductInfo } from "@scenes/pdp/utils/utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getProductBackGroundColor } from "@utils/product/productTheme";

const ProductHeaderView = ({
  itemDetail,
  otherDetail,
  currentIndex,
  productColor,
  priceMode,
  productType = "",
}: ProductHeaderViewProps) => {
  const { t } = useTranslation();
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);
  const { productName } = useProductInfo(
    t,
    productType,
    itemDetail,
    isCustomApp
  );
  const pdpLayout = usePdpLayout();
  const showAvailabilityDot = useAvailabilityData(
    pdpLayout?.[productType ?? ""]?.availabilty_price_modes ?? [
      PriceModes.GREEN,
      PriceModes.ORANGE,
      PriceModes.WHITE,
    ]
  );
  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.productHeader.primary">
          <LeftLabelContainer keyMargin={20}>
            <ProductHeaderDetail
              itemDetail={itemDetail}
              productColor={productColor}
              priceMode={priceMode}
              productAlphaColor={getProductBackGroundColor(productType)}
              productName={productName}
              hideReportIssue={true}
              showAvailabilityDot={showAvailabilityDot}
            />
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView testID="findMatch.productHeader.secondary">
          <LeftLabelContainer keyMargin={20}>
            <ProductHeaderDetail
              itemDetail={otherDetail?.[currentIndex]}
              productColor={productColor}
              priceMode={priceMode}
              productAlphaColor={getProductBackGroundColor(productType)}
              productName={productName}
              hideReportIssue={true}
              showAvailabilityDot={showAvailabilityDot}
            />
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  ${({ theme }) => matchPairConatinerWidth(theme)}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
`;

const LeftLabelContainer = styled.View<any>`
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin: ${({ keyMargin }) => `10px ${keyMargin}px`};
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;

export default ProductHeaderView;
